module.exports = __webpack_public_path__ + "static/img/Door_Bifold.41940f2.jpg";